
<div class='fix-target container {{mode}} {{fix}}' ref:fixTarget>

	<StLouis sceneIndex={{sceneIndex}} />

</div>


<style>
	.container {
		position: absolute;
		width: 100vw;
		max-width: 1180px;
		height: 100vh;
		z-index: 1000;
		overflow: hidden;
		box-sizing: border-box;
		-webkit-transition: opacity 4s;
		transition: opacity 4s;
		pointer-events: none;
	}

	.landscape .container {
		max-height: 600px;
		/*max-width: 960px;*/
	}

	@media (min-width: 740px) {
		.container { max-width: 100% }
	}

	@media (min-width: 980px) {
		/*.container { max-width: 980px; }*/
		.container { max-width: 100% }
	}

	@media (min-width: 1180px) {
		.container { max-width: 1180px; }
	}

	@media (min-width: 1300px) {
		.container { max-width: 1180px; }
	}

	.fixed {
		position: fixed;
		top: 50%;
		-webkit-transform: translate(0,-50%);
		transform: translate(0,-50%);
	}

	.top { top: 0; }
	.bottom { bottom: 0; }

	.mobile .container {
		position: fixed;
		opacity: 0;
		width: 100vw;
		height: 100vh;
		padding-bottom: 0;
	}

	.mobile .fixed {
		opacity: 1;
		-webkit-transition: opacity 5s;
		transition: opacity 5s;
	}
</style>

<script>
import StLouis from './StLouis.html';
export default {
	data () {
		return {
			// isMobile,
			// inIosApp,
			// sceneIndex: 0,
			// scenes
		};
	},
	components: {
		StLouis
	}
};

</script>
